<template>
    <button class="play-button" :class="paused ? 'play-button--paused' : ''" />
</template>

<script>
export default {
    name: 'PlayButton',
    props: {
        paused: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
@import '@speechki-frontend/shared/assets/scss/_vars';

.play-button {
    position: relative;
    height: 18px;
    width: 18px;
    border: none;
    background-color: #d4daed;
    outline: none;
    border-radius: 50%;
    background-image: url('@speechki-frontend/shared/assets/img/small-play.svg');
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover,
    &.is-active {
        background-color: var(--primaryColor);
    }

    // &:active {
    //     background-color: darken($orange, 10%);
    // }

    &--paused {
        background-image: url('@speechki-frontend/shared/assets/img/small-pause.svg');
    }
}
</style>
